import { useCurrentLocation, useOAuth } from "#imports";
import { Role } from "~/enums/role";
import type { UserProfile } from "~/types/api";

export async function getCurrentUserProfile(): Promise<UserProfile | undefined> {
  const { currentLocationId } = useCurrentLocation();
  const { user } = await useOAuth();

  if (!user.value?.profiles) {
    return undefined;
  }

  return user.value.profiles.find((profile) => profile.location.id === currentLocationId.value);
}

export default async () => {
  const currentUserProfile: UserProfile | undefined = await getCurrentUserProfile();

  if (currentUserProfile === undefined) {
    return {
      currentUserProfile: undefined,
      isPatient: false,
      isEmployee: false,
      isPhysio: false,
      isLocationManager: false,
      isOrganizationManager: false,
      isAlphaUser: false,
    };
  }

  const isPatient = currentUserProfile.roles.includes(Role.Patient);
  const isEmployee = currentUserProfile.roles.includes(Role.Employee);
  const isPhysio = currentUserProfile.roles.includes(Role.Physio);
  const isLocationManager = currentUserProfile.roles.includes(Role.LocationManager);
  const isOrganizationManager = currentUserProfile.roles.includes(Role.OrganizationManager);
  const isAlphaUser = currentUserProfile.roles.includes(Role.AlphaUser);

  return {
    currentUserProfile,
    isPatient,
    isEmployee,
    isPhysio,
    isLocationManager,
    isOrganizationManager,
    isAlphaUser,
  };
};
